/**
 * Lawyer Amadeus Console page
 * Uses shared AmadeusConsole component
 */
import { createRoute } from '@tanstack/react-router'
import { lawyerRoute } from './index'
import { AmadeusConsole } from '@/components/amadeus'

function ConsolePage() {
  return (
    <div className="h-full flex flex-col p-6 lg:p-8">
      <AmadeusConsole />
    </div>
  )
}

export const lawyerConsoleRoute = createRoute({
  getParentRoute: () => lawyerRoute,
  path: '/console',
  component: ConsolePage,
})
